import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { TRANSITION_TO_ADDING_ITEMS } from 'src/app/checkout/components/checkout-process/checkout-process.graphql';
import { GetActiveOrderQuery, TransitionToAddingItemsMutation } from '../../../common/generated-types';
import { ActiveService } from '../../providers/active/active.service';
import { DataService } from '../../providers/data/data.service';
import { StateService } from '../../providers/state/state.service';


@Injectable({
  providedIn: 'root',
})
export class CartFacade {
    private dataService = inject(DataService);
    private activeService = inject(ActiveService);
    private stateService = inject(StateService);
    private router = inject(Router);

    continuePurchasing() {
        return this.dataService
            .mutate<TransitionToAddingItemsMutation>(TRANSITION_TO_ADDING_ITEMS)
            .pipe(
            tap(result => {
                const order = result.transitionOrderToState;
                if (order?.__typename === 'Order') {
                this.activeService.setActiveOrder(order as GetActiveOrderQuery['activeOrder']);

                this.stateService.setState('cartDrawerOpen', false);

                if (!this.router.url.startsWith('/cart')) {
                    this.router.navigate(['/checkout']);
                }
                }
            })
        );
    }

}
